/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useCallback, FC, ReactElement } from 'react';
import {
  BackErrorType,
  ErrorProviderType,
  ErrorType,
  WarningType,
} from '../types/Types';
import { BackMappings } from '../utils/BackMappings';
import { SessionChecker } from '../utils/SessionChecker';
import { useAppStore } from './AppContext';

export const defaultErrorValue = {};

export const APIErrorContext = React.createContext<ErrorProviderType>(
  defaultErrorValue as ErrorProviderType,
);

type Props = {
  children: ReactElement;
};

export const APIErrorProvider: FC<Props> = ({ children }) => {
  const [error, setError] = useState<ErrorType>({} as ErrorType);
  const [errorBack, setErrorBack] = useState<BackErrorType>(
    {} as BackErrorType,
  );
  const [warning, setWarning] = useState<WarningType>({} as WarningType);
  const [oro, setOro] = useState<boolean>(false as boolean);
  const { lang } = useAppStore();

  const removeError = () => {
    setError({} as ErrorType);
    setErrorBack({} as BackErrorType);
    setWarning({} as WarningType);
  };

  const addError = (message: string, status: string, style = false) => {
    setError({ message, status, style });
    setOro(false);
  };

  const addErrorBack = (err: BackErrorType) => {
    const errorCode = err.errorCode as number;
    if (
      errorCode &&
      (errorCode === BackMappings.GO_TO_LOGIN || errorCode === 1)
    ) {
      SessionChecker.closeSessionAndGoToLogin(null, lang);
    } else if (errorCode && errorCode === BackMappings.GO_TO_RELOGIN) {
      SessionChecker.closeSessionAndGoToReLogin(null, lang);
    } else {
      setErrorBack(err);
      setOro(false);
    }
  };

  const addWarning = (message: string) => {
    setWarning({ message });
  };

  const addOro = (isOro: boolean) => setOro(isOro);

  const contextValue = {
    error,
    errorBack,
    warning,
    oro,
    addError: useCallback(
      (message: string, status: string, style: boolean) =>
        addError(message, status, style),
      [],
    ),
    addErrorBack: useCallback((err: BackErrorType) => addErrorBack(err), []),
    addWarning: useCallback((message: string) => addWarning(message), []),
    removeError: useCallback(() => removeError(), []),
    addOro: useCallback((isOro: boolean) => addOro(isOro), []),
  } as ErrorProviderType;

  return (
    <APIErrorContext.Provider value={contextValue}>
      {children}
    </APIErrorContext.Provider>
  );
};
